$('.dhsv_vc_list_element_dropdown').on('click', '.toggle_content', function () {
  $(this).toggleClass('opened').siblings('.hidden_content').slideToggle()
})
